export const ROOM_ANONYMOUS_PRESENTER_EMAIL_MAX_LENGTH = 100;
